import { MenuItem } from "@kaltura/ds-react-components";
import { useState } from "react";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import ArchiveKwebcastVodModal, { ArchiveKwebcastVodProps } from "./modal/ArchiveKwebcastVodModal";
import { translate } from "@kaltura/mediaspace-shared-utils";

export interface ArchiveKwebcastVodMenuItemProps extends ArchiveKwebcastVodProps {
    autoFocus?: boolean;
    recordingDetached?: boolean;
}

/**
 * Archive Kwebcast VOD menu item for media-page title area actions menu
 */
export const ArchiveKwebcastVodMenuItem = (props: ArchiveKwebcastVodMenuItemProps) => {
    const { autoFocus, recordingDetached, ...modalProps } = props;

    const [isOpen, setIsOpen] = useState<boolean>(false);

    const sendButtonAnalytics = useButtonAnalytics();

    const openArchiveKwebcastVodModal = () => {
        sendButtonAnalytics("Media Actions - Detach recording", ButtonClickAnalyticsType.LAUNCH);
        setIsOpen(true);
    };

    if (recordingDetached) {
        // after successfully detaching the recording, the menu item should no longer appear.
        // this prop is set in the modal after a successful operation.
        return null;
    }

    return (
        <>
            <MenuItem key={"archive-kwebcast-vod"} onClick={openArchiveKwebcastVodModal} autoFocus={autoFocus}>
                {translate("Detach recording")}
            </MenuItem>

            <ArchiveKwebcastVodModal {...modalProps} isOpen={isOpen} />
        </>
    );
};

export default ArchiveKwebcastVodMenuItem;
